import { render, staticRenderFns } from "./MyDatamatrixEdit.vue?vue&type=template&id=1fdeb25b"
import script from "./MyDatamatrixEdit.vue?vue&type=script&lang=js"
export * from "./MyDatamatrixEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports